<template>
	<div>
		<div class="lg:flex">
			<div class="lg:w-1/3 flex lg:mr-3">
				<img src="@/assets/img/buscar.svg" class="p-2" />
				<input
					v-model="search"
					@keyup="onChangeSearch()"
					class="
						w-24R
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
					v-bind:placeholder="$t('search')"
				/>
			</div>
			<div class="lg:w-1/3 lg:mr-3">
				<label class="pr-5">{{ $t('Rol') }}</label>
				<select
					v-model="rol_id"
					@change="onChangeRol()"
					class="
						w-24R
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				>
					<option value=""></option>
					<option v-for="role in roles" :value="role.id" v-bind:key="role.id">
						{{ role.rol }}
					</option>
				</select>
			</div>
			<div class="lg:w-1/3 flex justify-end">
				<ButtonBlack class="mr-1">
					<router-link
						:to="'/admin/' + section"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
				<!-- <ButtonBlack>
            <router-link to="/admin/alta-usuarios" class="text-white no-underline">
              <div class="flex items-center">
                <img src="@/assets/img/anadir-archivo.svg" class="pr-1">
                <span>{{$t("bulk_upload")}}</span>
              </div>
            </router-link>
          </ButtonBlack> -->
			</div>
		</div>
		<ListTable
			:itemsTitles="itemsTitles"
			:items="users"
			:itemsTable="itemsTable"
			:section="section"
		/>
	</div>
</template>

<script>
import ListTable from '@/components/ListTable'
import gql from 'graphql-tag'

export default {
	apollo: {
		roles: gql`
			{
				roles(order_by: { rol: asc }) {
					id
					rol
				}
			}
		`,
		users: {
			query: gql`
				query ($rol_id: bigint, $search: String) {
					users(
						where: {
							rol_id: { _eq: $rol_id }
							_or: [
								{ dni: { _ilike: $search } }
								{ email: { _ilike: $search } }
								{ name: { _ilike: $search } }
								{ lastname: { _ilike: $search } }
							]
						}
					) {
						id
						dni
						name
						lastname
						role {
							rol
							is_administrator
            				allow_hiring
						}
						email
						active
					}
				}
			`,
			skip() {
				return this.skip
			},
			update(data) {
				return data.users.map(item => ({
					id: item.id,
					dni: item.dni,
					nombre: [item.name, item.lastname].join(' '),
					rol: item.role ? item.role.rol : '',
					hires: item.role.allow_hiring ? this.$t('Si') : this.$t('No'),
					admin: item.role.is_administrator ? this.$t('Si') : this.$t('No'),
					email: item.email,
					activeText: item.active ? this.$t('Si') : this.$t('No'),
					edit: true,
					active: item.active
				}))
			}
		}
	},
	mounted(){
		this.skip = false
		this.$apollo.queries.users.refetch({
			search: `%%`,
			rol_id: 1
		})
	},
	data() {
		return {
			skip: true,
			search: '',
			rol_id: 1,
			section: 'usuarios',
			itemsTable: 'users',
			itemsTitles: ['Id', 'DNI', 'Nombre', 'Rol', 'Contratación', 'Administrador','Email', 'Activo']
		}
	},
	components: { ListTable },
	methods: {
		onChangeRol() {
			this.skip = false
			this.$apollo.queries.users.refetch({
				rol_id: isNaN(parseInt(this.rol_id)) ? undefined : this.rol_id
			})
		},
		onChangeSearch() {
			this.skip = false
			this.$apollo.queries.users.refetch({
				search: `%${this.search}%`
			})
		}
	}
}
</script>

<style scoped>
.w-24R {
	width: 24rem;
}
</style>
